module.exports = __webpack_public_path__ + "img/rappi.8c70e1c1.jpeg";